import KliraCartCoupon from '../obj/KliraCartCoupon.js';
import KliraCartItem from '../obj/KliraCartItem.js';

window.purchase = {
    // stores details of the last purchase
    checkout: {
        chargebeeInvoiceIds: null,
        chargebeeSubscriptionIds: null,
        email: null,
        first_name: null,
        last_name: null,
        phone: null,
        billing: {},
        shipping: {},
        shipToBillingAddress: null,
        subTotal: null,
        total: null,
        totalUpsellDiscountAmount: 0,
    },
    items: [], // array of KliraCartItem
    coupons: [], // array of KliraCartCoupon

    // utility methods
    hasMadePurchase: function() {
        return this.checkout.email && this.checkout.email.length > 0;
    },

    hasPurchasedSubscription: function() {
        return this.items?.some(item => item.getProduct().isSubscription) || false;
    },

    getPurchaseTypes: function () {
        const PRODUCT_TYPES = {
            subscription: (product) => product.isSubscription,
            gift_card: (product) => product.isGiftCard,
            video_consult: (product) => product.isVideoConsultation,
        };

        const foundKeys = Object.keys(PRODUCT_TYPES).filter(key =>
            this.items.some(item => {
                const product = item.getProduct?.();
                return product && PRODUCT_TYPES[key](product);
            })
        );

        return foundKeys.length ? foundKeys.join('_') : "no items purchased";
    },

    // persist methods
    clear: function() {
        console.log('PURCHASE: Clearing data');
        this.checkout = {
            chargebeeInvoiceIds: null,
            chargebeeSubscriptionIds: null,
            email: null,
            first_name: null,
            last_name: null,
            phone: null,
            billing: {},
            shipping: {},
            shipToBillingAddress: null,
            subTotal: null,
            total: null,
        };
        this.items = [];
        this.coupons = [];

        localStorage.removeItem('purchase/complete/checkout');
        localStorage.removeItem('purchase/complete/items');
        localStorage.removeItem('purchase/complete/coupons');
    },
    save: async function() {
        console.log('PURCHASE: Saving');
        // save checkout details, including some pricing info
        let checkoutDetails = {...window.checkout};
        checkoutDetails.subTotal = window.cart.getTotalPrice();
        checkoutDetails.total = window.cart.getDiscountedPrice();
        checkoutDetails.totalUpsellDiscountAmount = await window.upsellDiscounts.totalDiscountAmount() || 0;
        localStorage.setItem('purchase/complete/checkout', JSON.stringify(checkoutDetails));
        // save items and coupons
        localStorage.setItem('purchase/complete/items', JSON.stringify(window.cart.items));
        localStorage.setItem('purchase/complete/coupons', JSON.stringify(window.cart.coupons));
    },
    load: function() {
        if (!localStorage.getItem('purchase/complete/checkout')) {
            return;
        }

        console.log('PURCHASE: Loading');

        this.checkout = JSON.parse(localStorage.getItem('purchase/complete/checkout'));

        if (localStorage.getItem('purchase/complete/items')) {
            // load cart items
            let storedItems = JSON.parse(localStorage.getItem('purchase/complete/items'));

            // map through and convert all to KliraCartItem
            this.items = storedItems.map(function (item) {
                return new KliraCartItem(item.product, item.quantity, item.additionalFields);
            });
        }

        if (localStorage.getItem('purchase/complete/coupons')) {
            // load cart coupons
            let storedItems = JSON.parse(localStorage.getItem('purchase/complete/coupons'));

            // map through and convert all to KliraCartCoupon
            this.coupons = storedItems.map(function (item) {
                return new KliraCartCoupon(item.code, item.discountAmount);
            });
        }
    }
}

// load any purchase details immediately
window.purchase.load();